import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAdminUsers } from '@actions/adminUsers/fetchAllAdminUsers';
import { getAdminUserPostSuccess } from '@selectors/adminUsers';
import usePrevious from 'lib/src/hooks/usePrevious';
import { getSuperAdminUserPostSuccess } from '@selectors/superAdminUsers';

const useAdminUsersFetch = (): void => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchAllAdminUsers());
    }, [dispatch]);

    const postSuccess = useSelector(getAdminUserPostSuccess);
    const postSuperAdminSuccess = useSelector(getSuperAdminUserPostSuccess);
    const prevSuccess = usePrevious(postSuccess);
    const prevSuperAdminSuccess = usePrevious(postSuperAdminSuccess);

    useEffect(() => {
        if ((postSuccess && !prevSuccess) || (postSuperAdminSuccess && !prevSuperAdminSuccess)) {
            dispatch(fetchAllAdminUsers());
        }
    }, [postSuccess, prevSuccess, postSuperAdminSuccess, prevSuperAdminSuccess, dispatch]);
};

export default useAdminUsersFetch;
